import React, { useEffect, useState } from "react";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import {
  setPage,
  setRowsPerPage,
  setSearchValue,
  setIsTableLoading,
  setItems,
  setTotalItems,
} from "src/redux/slices/DuesSlice";
import { useGetAllTransactionForExcelMutation } from "src/services/TransactionService";
import { formatedDateTimeIntoIst } from "src/utils/formUtils/dateTimeFormate";
import moment from "moment";
import { Tooltip } from "@mui/material";
import { useGetDueAmountReportQuery } from "src/services/DashboardService";
import DuesListing from "./DuesListing";
import EditDueAmountWrapper from "src/screens/Dashboard2/Edit/EditDueAmountWrapper";
import ATMMenu from "src/components/UI/atoms/ATMMenu/ATMMenu";
import ListDateTime from "src/components/UI/atoms/ListDateTime/ListDateTime";
import { usePermission } from "src/hooks/usePermission";

type Props = {};

const DuesListingWrapper = (props: Props) => {
  const dispatch = useDispatch();
  const {
    items,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    isTableLoading,
    dateFilter,
  } = useSelector((state: RootState) => state.dues);
  // const [excelPayemnt, setExcelPayemnt] = React.useState([]);
 const [isOpenEditDialog, setIsOpenEditDialog] = useState(false);
  const [selectedDueAmountId, setSelectedDueAmountId] = useState<string>("");
  const { data, isFetching, isLoading } = useGetDueAmountReportQuery({
    limit: rowsPerPage,
    searchValue: searchValue,
    params: ["name", "email", "mobile", "orderId"],
    page: page,
    filterBy: [],
    dateFilter: {
      startDate: dateFilter.start_date
        ? formatedDateTimeIntoIst(dateFilter.start_date, "YYYY-MM-DD")
        : "",
      endDate: dateFilter.end_date
        ? moment(dateFilter?.end_date).format("YYYY-MM-DD")
        : dateFilter.start_date
        ? moment().format("YYYY-MM-DD")
        : "",
      // : formatedDateTimeIntoIst(Date(), "YYYY-MM-DD"),
    },
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: true,
  });

  const [getDuesExcel, getPaymnetExcelInfo] =
    useGetAllTransactionForExcelMutation();

  useEffect(() => {
    if (isLoading || isFetching) {
      dispatch(setIsTableLoading(true));
    } else {
      dispatch(setItems(data?.data || []));
      dispatch(setTotalItems(data?.totalItem || 0));
      dispatch(setIsTableLoading(false));
    }
  }, [isLoading, isFetching, data]);
  const moduleName = "ORDER";

  const canEdit = usePermission(moduleName, "UPDATE");
    const columns: columnTypes[] = [
    { field: "orderNumber", headerName: "Order Number", flex: "flex-[1_1_0%]" },
    { field: "name", headerName: "Student Name", flex: "flex-[1_1_0%]" },
    { field: "mobile", headerName: "Mobile Number", flex: "flex-[1_1_0%]" },
    { field: "dueAmt", headerName: "Due Amount", flex: "flex-[1_1_0%]" },
    {
      field: "duedate",
      headerName: "Due Date",
      flex: "flex-[1_1_0%]",
      extraClasses: "min-w-[150px] py-1",
      renderCell: (row: any) => <ListDateTime value={row.duedate} />,
    },
    {
      field: "action",
      headerName: "Actions",
      flex: "flex-[1_1_0%]",
      extraClasses: "",
      renderCell: (row: any) => {
        const options = [];

        if (canEdit) {
          options.push({
            label: "Edit",
            onClick: () => {
              setIsOpenEditDialog(true);
              setSelectedDueAmountId(row?._id);
            },
          });
        }

        return <ATMMenu options={options} />;
      },
    },
  ];
  return (
    <div>
      <DuesListing
        columns={columns}
        getDuesExcel={getDuesExcel}
        isloadingExcel={getPaymnetExcelInfo.isLoading}
        rows={items}
        // excelData={excelPayemntData}
        paginationProps={{
          isTableLoading,
          totalItems,
          page,
          rowsPerPage,
          searchValue,
          setPage: (newPage) => dispatch(setPage(newPage)),
          setRowsPerPage: (newRowsPerPage) =>
            dispatch(setRowsPerPage(newRowsPerPage)),
          setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
        }}
      />
       {isOpenEditDialog && (
        <EditDueAmountWrapper
          onClose={() => setIsOpenEditDialog(false)}
          selectedDueAmountId={selectedDueAmountId}
        />
      )}
    </div>
  );
};

export default DuesListingWrapper;
